import { Headline3 } from 'aimo-ui';
import Info from 'components/common/Info';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components/native';
import { StyledWrapper } from 'styles/ContainerStyles';

export interface InfoCardProps {
  parkAndRideSteps: Array<{ icon: string; text: string; linkText?: string }>;
}

const InfoCard = styled.View`
  background-color: ${(p) => p.theme.colors.white};
  padding: 16px;
  margin: 20px;
  border-radius: 10px;
`;

const InfoCardComponent: React.FC<InfoCardProps> = ({ parkAndRideSteps }) => {
  const { t } = useTranslation();

  return (
    <InfoCard>
      <StyledWrapper ml={10}>
        <Headline3>{t('hslTicket.parkAndRideTutorial.title')}</Headline3>
      </StyledWrapper>

      {parkAndRideSteps.map((step, index, arr) => (
        <Info
          icon={step.icon}
          key={`icon-${step.icon}`}
          last={index === arr.length - 1}
          text={step.text}
        />
      ))}
    </InfoCard>
  );
};

export default InfoCardComponent;
